import { useOwnedAccount } from '@hotjar/account'; // TODO SV: CHECK THIS CIRCULAR DEPENDECY
import { useEffect } from 'react';
import type { RequireAtLeastOne } from 'type-fest';

interface AccountOwnerRouteProps {
  children: JSX.Element;
  fallbackUrl?: string;
  fallbackUI?: JSX.Element;
}

type EnrichedProps = RequireAtLeastOne<AccountOwnerRouteProps, 'fallbackUrl' | 'fallbackUI'>;

/**
 * A component that checks if a user is an account owner. Sends them to fallback url if they are not.
 *
 * <Route path="/<some_path>" element={
 *   <AccountOwnerRoute fallbackUrl="/fallback-route">
 *     <MyComponent />
 *   </AccountOwnerRoute>
 * } />
 */
export const AccountOwnerRoute = ({
  children,
  fallbackUrl,
  fallbackUI,
}: EnrichedProps): JSX.Element | null => {
  const { data: ownedAccount, isFetched } = useOwnedAccount();

  useEffect(() => {
    if (!ownedAccount && isFetched && fallbackUrl !== undefined && fallbackUrl.length > 0) {
      const fallbackLocation = new URL(fallbackUrl, window.location.href);
      window.location.href = fallbackLocation.toString();
    }
  }, [ownedAccount, fallbackUrl, isFetched]);

  if (ownedAccount && isFetched) {
    return children;
  }

  if (!ownedAccount && isFetched && fallbackUI !== undefined) {
    return fallbackUI;
  }

  return null;
};
